export const checkUrl = (url: string) => {
  const redirectUrl = new URL(url, window.location.origin);
  if (redirectUrl.origin === window.location.origin) {
    return url;
  } else {
    throw new Error(
      `Redirect origin does not match current origin: ${redirectUrl.origin} !== ${window.location.origin}`,
    );
  }
};
